import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { urlToPattern } from "../urlToPattern";
import logo from "./logo.svg";

export const veza = defineConnector({
  identifier: "veza",
  name: "Veza",
  tagLine: "Identity security and access visibility",
  logo,
  protocol: "http",
  tags: ["identity", "security"],
  auth: (app) => bearerAuth(app.secret.apiKey),
  steps: [
    {
      title: "Create a Veza API key",
      items: [
        {
          kind: "markdown",
          content:
            "In Veza, create an OAA API key and use it as a bearer token for API requests.",
        },
      ],
    },
    {
      title: "Enter your Veza details",
      items: [
        {
          kind: "baseUrl",
          label: "Veza base URL",
          required: true,
          placeholder: "https://your-company.veza.com",
          target: { kind: "configuration", field: "instanceUrl" },
        },
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ instanceUrl }) =>
      `${instanceUrl || "https://your-company.veza.com"}/api/v1/providers/custom`,
  },
  defaultUrlPattern: ({ instanceUrl }) =>
    urlToPattern(instanceUrl, "https://[^/]*\\.veza\\.com/.*"),
});
